import { render, staticRenderFns } from "./Participants.vue?vue&type=template&id=4b0f6234&scoped=true"
import script from "./Participants.vue?vue&type=script&lang=js"
export * from "./Participants.vue?vue&type=script&lang=js"
import style0 from "./Participants.vue?vue&type=style&index=0&id=4b0f6234&prod&lang=css&scoped=true"
import style1 from "./Participants.vue?vue&type=style&index=1&id=4b0f6234&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f6234",
  null
  
)

export default component.exports